import { createContext, useState } from "react";

const ErrorContext = createContext();

export function ErrorProvider({children})  {
    const [errorContext, setErrorContext] = useState();

    return (
        <ErrorContext.Provider value={{errorContext, setErrorContext}}>
            {children}
        </ErrorContext.Provider>
    )
}

export default ErrorContext;